import { render, staticRenderFns } from "./AddProjectModal.vue?vue&type=template&id=685cc1b8"
import script from "./AddProjectModal.vue?vue&type=script&lang=ts"
export * from "./AddProjectModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports